<template>
  <Modal
    hide-close-button
    :modal-style="{ width: '40vw', 'max-height': '100%' }"
    :title="modalTitle"
  >
    <div class="q-gutter-md">
      <span class="q-mb-sm block">
        <strong>Schedule:</strong> {{ deliveryDays }}
      </span>

      <span class="q-mb-sm block">
        <strong>Deliver at:</strong> {{ deliveryTime }}
      </span>

      <span class="q-mb-sm block">
        <strong>Mentions since:</strong> {{ mentionsPeriod }}
      </span>

      <div class="row justify-between">
        <Calendar
          v-model="localDate"
          class="date-selector q-mt-sm q-mb-none q-pa-none"
        />
      </div>
      <ScheduledReportsTable
        v-model:pagination="pagination"
        :reports="scheduledReports"
      />
    </div>

    <template #buttons>
      <a
        class="q-mr-md text-black"
        href="#"
        @click.prevent="close"
      >
        Close
      </a>
    </template>
  </Modal>
</template>

<script>
import endOfDay from "date-fns/endOfDay";
import startOfDay from "date-fns/startOfDay";

import Modal from "shared/components/core/modals/Modal.vue";
import { parseDate } from "shared/helpers/date";
import { ScheduledReportSpecification } from "shared/resources";

import Calendar from "src/components/common/Calendar.vue";
import ScheduledReportsTable from "src/components/scheduled_reports/ScheduledReportsTable.vue";

export default {
  name: "ScheduledReportSpecificationModal",
  components: {
    Modal,
    ScheduledReportsTable,
    Calendar,
  },
  props: {
    scheduleReportSpecification: {
      type: Object,
      required: true,
    },
    deliveryDays: {
      type: String,
      default: "",
    },
    deliveryTime: {
      type: String,
      default: "",
    },
    mentionsPeriod: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      localDate: null,
      scheduledReports: [],
      pagination: {
        rowsPerPage: 100,
        page: 1,
      },
    };
  },
  computed: {
    endOfDay() {
      return parseDate(endOfDay(new Date(this.localDate))).toISOString();
    },
    startOfDay() {
      return parseDate(startOfDay(new Date(this.localDate))).toISOString();
    },
    oneYearAgo() {
      return parseDate(
        new Date().setFullYear(new Date().getFullYear() - 1)
      ).toISOString();
    },
    modalTitle() {
      return `#${this.scheduleReportSpecification.id} - ${this.scheduleReportSpecification.subject}`;
    },
  },
  watch: {
    localDate: {
      deep: true,
      handler() {
        this.loadScheduledReports();
      },
    },
  },
  mounted() {
    this.loadScheduledReports();
  },
  methods: {
    close() {
      this.$modals.close("ScheduledReportSpecificationModal");
    },
    async loadScheduledReports() {
      try {
        let filters = {
          "scheduledReports.createdAt": {
            gt: this.oneYearAgo,
          },
        };

        if (this.localDate) {
          filters = {
            "scheduledReports.createdAt": {
              lt: this.endOfDay,
              gt: this.startOfDay,
            },
          };
        }

        const scheduledReportSpecification = (
          await ScheduledReportSpecification.includes(["scheduledReports"])
            .where(filters)
            .order({ "scheduledReports.id": "desc" })
            .find(this.scheduleReportSpecification.id)
        ).data;

        this.scheduledReports = scheduledReportSpecification.scheduledReports;
      } catch (error) {
        this.$error("Something went wrong loading scheduled reports", error);
      }
    },
  },
};
</script>
